import api from './axios';

export async function getOverallRating(contractId, reviewTypeId) {
    const { data } = await api.get(`/api/contracts/${contractId}/overall-rating`, {
        params: { review_type_id: reviewTypeId },
    });
    return data; // { overall, review_type }
}

export async function getOverallEligibility(contractId) {
    const { data } = await api.get(`/api/contracts/${contractId}/overall/eligibility`);
    return data; // { ok, errors: [] }
}

export async function updateOverallEmployee(overallId, payload) {
    const { data } = await api.put(`/api/overall-ratings/${overallId}/employee`, payload);
    return data;
}

export async function updateOverallManager(overallId, payload) {
    const { data } = await api.put(`/api/overall-ratings/${overallId}/manager`, payload);
    return data;
}

export async function acceptOverall(overallId) {
    const { data } = await api.post(`/api/overall-ratings/${overallId}/accept`);
    return data;
}